import "./auth.scss";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { IUserLogin } from "../../service/types/user.data";
import pluriLogo from "./../../image/logo.png";
import { LoginService } from "src/service/api-services/api-services";
import showToast from "@utils/toast";
import { IAuth } from "src/types";
import { isTokenExpired } from "@utils/authUtils";

const email_prefix = "@pluritongues.com";

/**
 * A function that checks to make sure that the
 * provided email a pluritongues email.
 * @param email
 * @returns
 */
function validatePluritonguesEmail(email: string): boolean {
  // making sure that that the email is not empty
  if (!email) {
    return false;
  }

  //making sure that the email are pluritongues email
  //ps: we could use a regular expression
  if (!email.includes(email_prefix)) {
    return false;
  }

  return true;
}

/**
 * A function that checks if the password is correct
 * @param password
 * @returns
 */
function validatePassword(password: string): boolean {
  if (!password) {
    return false;
  }
  return true;
}

const LogIn: React.FC = () => {
  // change the IUserLogin to IUserLoginData
  const [loginData, setLoginData] = useState<IUserLogin>({
    email: "",
    password: "",
  });
  const [error, setError] = useState<string | undefined>(undefined);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const navigate = useNavigate();
  const location = useLocation();

  // Redirect immediately if already logged in
  const token = localStorage.getItem("accessToken");
  useEffect(() => {
    if (token && !isTokenExpired(token)) {
      navigate("/dashboard");
    }
  }, [token, navigate]);

  const handleLogin = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setIsLoading(true);
    setError(undefined);
    const { password, email } = loginData;

    const payload = { email, password, role: "admin" };

    try {
      localStorage.setItem("user_email", email);
      const authRequest: IAuth = await LoginService(payload);

      if (authRequest.status === "success" && authRequest.result.requires2FA) {
        localStorage.setItem(
          "loginSessionId",
          authRequest.result.loginSessionId
        );
        showToast("Login successful. Account verification required.", true);
        navigate("/otp-verification");
      } else {
        showToast(`${authRequest.message}`, false);
        return;
      }
    } catch (err: any) {
      showToast(`${err?.message}`, false);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="login-container fadeInDown">
      <div id="formContent">
        {/* Icon */}
        <div className="fadeIn first flex justify-center my-3">
          <img
            src={pluriLogo}
            alt="User Icon"
            style={{
              width: "150px",
              marginBottom: "10px",
              marginTop: "5px",
            }}
          />
        </div>

        <h1 className="auth-title">Pluritongues LAMS</h1>

        {/* Login Form */}
        <form onSubmit={handleLogin}>
          <input
            type="email"
            id="user"
            className="auth-inputs fadeIn second"
            name="email"
            placeholder="Email"
            value={loginData.email}
            onChange={(e) =>
              setLoginData({ ...loginData, email: e.target.value })
            }
          />
          <input
            type="password"
            id="password"
            className="auth-inputs fadeIn third"
            name="password"
            placeholder="Password"
            value={loginData.password}
            onChange={(e) =>
              setLoginData({ ...loginData, password: e.target.value })
            }
          />

          {/* <input type="submit" className="fadeIn fourth" value="Log In" /> */}
          <button
            type="submit"
            className="auth-button fadeIn fourth"
            disabled={isLoading}
          >
            {isLoading ? "Loading..." : " Login"}
          </button>
        </form>

        {error && (
          <div className="error-message err-message-color">{error}</div>
        )}

        {/* password issues  */}
        <div id="formFooter">
          <a className="forgot-password" href="/forgot-password">
            Forgot Password?
          </a>
        </div>
      </div>
    </div>
  );
};

export default LogIn;
